<template>
  <div id="app">
    <gec-header/>
    <router-view/>
    <gec-footer/>
  </div>
</template>

<script>
import GecHeader from '@/components/gecHeaderNew';
import GecFooter from '@/components/gecFooter';
// import { post } from '@/utilitys/gecAxios'

export default {
  name: 'App',
  components: {
    GecHeader,
    GecFooter
  },

  methods: {
    // async getUserInfo () {
    //   let { data: res } = await post(
    //     `/login/check`,
    //     {
    //     // productId: ID
    //     })
    //   if (res.error.returnCode !== 0) {
    //     location.href = 'https://sso.gecacademy.cn/login'
    //   }
    // }
  }
}
</script>

<style>
body {
  background: #f4f4f4;
  margin: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  margin-top: 60px;
}

.container {
  width: 1080px;
  padding: 0;
  margin: 20px auto;
}

/* 骚气且统一的卡片动画 */
.gec-hover-card {
  transition: all 0.5s cubic-bezier(0.46, -1.96, 0.29, 1.14);
  box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.2);
}

.gec-hover-card:hover {
  box-shadow: 2px 4px 8px 0 rgba(46, 61, 73, 0.2);
}
</style>


// WEBPACK FOOTER //
// src/App.vue